import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-EPM",
  "use": "dv-EPM-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"dv-EPM\"><defs><style>#dv-EPM .cls-1{fill:#fff1de;fill-opacity:0;}</style></defs><title>20</title><g id=\"dv-EPM_图层_2\" data-name=\"图层 2\"><g id=\"dv-EPM_图层_1-2\" data-name=\"图层 1\"><rect id=\"dv-EPM_矩形_279\" data-name=\"矩形 279\" class=\"cls-1\" width=\"17\" height=\"17\" /><g id=\"dv-EPM_组_2472\" data-name=\"组 2472\"><path id=\"dv-EPM_减去_178\" data-name=\"减去 178\" d=\"M14.78,15.9H2a1,1,0,0,1-1-1V2.12a1,1,0,0,1,1-1H14.78a1,1,0,0,1,1,1V14.9A1,1,0,0,1,14.78,15.9Zm-2.1-8.06h0v.09c0,.33-.06.75-.06,1.05V10.8h.54V7.11H12.5L11.83,9l-.12.37c0,.12-.07.25-.12.37h0c0-.12-.09-.25-.12-.37s-.08-.25-.13-.37l-.67-1.87H10V10.8h.52V9c0-.26,0-.61-.05-.92h0c0-.07,0-.14,0-.21h0l.29.85.65,1.76h.36l.64-1.76.29-.85ZM6.75,7.11V10.8h.58V9.4h.55c.88,0,1.39-.42,1.39-1.17s-.48-1.11-1.4-1.11Zm-3,0V10.8H6v-.49H4.33V9.12H5.68V8.63H4.33v-1H5.92V7.11ZM7.83,8.94h-.5V7.58H7.8c.63,0,.89.2.89.65S8.42,8.94,7.83,8.94Z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-EPM.svg
// module id = IXNn
// module chunks = 268